import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteRelatorioPrestacaoContas() {
  return useMutation(
    (id: string) => {
      return http.delete(`/v1/relatorios/financeiro/prestacao-contas/${id}`);
    },
    { retry: false }
  );
}

export default useDeleteRelatorioPrestacaoContas;
